import defaultState from "./state";


const cargarPaginacionReducer = (state = defaultState, action) => {
  switch (action.type) {
    case "CARGAR_PAGINACION": {
      return Object.assign({}, state, {
        pageSize: action.paginacion[0].pageSize,
        totalPage: action.paginacion[0].totalPage,
      });
    }
    case "CARGAR_PRESTACIONES_PP": {
      return Object.assign({}, state, {
        prestacionesPP: action.prestacionesPP,
      });
    }

    default:
      return state;
  }
};


export default cargarPaginacionReducer;



// WEBPACK FOOTER //
// ./src/components/PaginacionV2/reducer.js